import VHorizontalNavigation from './VHorizontalNavigation.vue';

export { default as VNavItem } from './VNavItem.vue';
export default VHorizontalNavigation;
